import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import styles from '../style.js';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';

class SignVerifyDialog extends React.Component {
  state = {
    open: false,
    signerId:0,
    signerInfos:[],
    resulList:[],
    expandAccordion:''
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.props.onClose();
  };

  signerChange = event => {
    const fieldName = event.target.name;
    const fieldValue = event.target.value;

    this.setState({ [fieldName]: fieldValue });

    const { verifyInfos } = this.props;

    const verifyInfo = verifyInfos.find(signer => signer.id === fieldValue);
    if (verifyInfo) {
      this.setState({ signerInfos: verifyInfo.signerInfos, resulList: verifyInfo.resulList,expandAccordion:'panel1' });
    }
  };  

  accordionChange = (panel) => (event, newExpanded) => {
    this.setState({expandAccordion:''})
  }

  render() {
    const { verifyInfos } = this.props;
    const { signerId,signerInfos,resulList,expandAccordion } = this.state;

    return (
      <div>
        <Dialog
          fullWidth={true}
          maxWidth={"sm"}
          open={this.props.open}
          onClose={this.handleClose}
        >
          <DialogTitle id="responsive-dialog-title"><h4>Doğrulama Sonucu</h4></DialogTitle>
          <DialogContent>
          <InputLabel id="signerLabel" style={styles.label}>İmzacılar</InputLabel>
          <Select
            className='customSelect'
            fullWidth
            labelId="signerLabel"
            id="signerSelect"
            value={signerId}
            name="signerId"
            style={styles.selectField}
            onChange={this.signerChange}>
            {verifyInfos.map((signer) => (
              <MenuItem value={signer.id}>
                <div style={styles.selectField}>{signer.name}</div>
              </MenuItem>
            ))}
          </Select>
          <Accordion expanded={expandAccordion === 'panel1'} onChange={this.accordionChange('panel1')}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>İmzalayan Bilgileri</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Table aria-label="simple table">
                <TableBody>
                  {signerInfos.map((row) => (
                    <TableRow>
                      <TableCell component="th" scope="row" sx={styles.cellName}>               
                        <strong>{row.name}</strong> 
                      </TableCell>
                      <TableCell sx={styles.cellDetail}>{row.detail}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>İmza Detay Bilgileri</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Table aria-label="simple table">
                <TableBody>
                  {resulList.map((row) => (
                    <TableRow>
                      <TableCell sx={styles.cellDetail}>{row.detail}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </AccordionDetails>
          </Accordion>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Tamam
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

SignVerifyDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired
};

export default withMobileDialog()(SignVerifyDialog);
